import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';
import { Tenant } from './models/tenant';
import { User } from './models/user';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { Role } from "./models/role";
import { RepresentativeModel } from "./order-to-cash/models-otc/representative-model";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: 'root'
})
export class HelperService {
 tenantId: number;
  userId: number;

  tmpList: any[] = [];
  tmpList1: any[] = [];

  private roles: Role[];

  private representative: any;

  constructor(
    public auth: AuthService,
    public nav: NavBarComponent,
    public translate: TranslateService
  ) { }

  getUserId() {
    if (sessionStorage.getItem("user") != null) {
      let user: User = JSON.parse(sessionStorage.getItem('user'));
      return user.id;
    } else {
      this.auth.user$.subscribe((user) => {
        if (user != null) {
          return user.id;
        }
      })
    }
  }

  // getAgentId() {
  //   // console.log(JSON.parse(sessionStorage.getItem('currentAgent')))
  //   let currentAgent =  JSON.parse(sessionStorage.getItem('currentAgent'));

  //   if(currentAgent) {
  //     return currentAgent.agentUserId;
  //   } else {
  //     let user: User = JSON.parse(sessionStorage.getItem('user'));
  //     return user.id;
  //   }
  // }


  isRepresentative(request: string) {
    this.roles = JSON.parse(sessionStorage.getItem('roles'));
    if(request?.length > 0 && this.roles?.length > 0) {
      let repArray = Object.entries(environment.representatives).find(([key, val]) => request.includes(key));

      if(repArray?.length > 0 && this.roles.some(item => item.name === repArray[1])) {
        /*
        !environment.submissionApproval.test(request)
        Ensures that the agronomist users' id is part of the x-application-user-id when approving a lab result/submission.
        Without it if the agronomist user is the representative, the lab result/submission will be approved with the agent id causing issues.
         */
        return !environment.submissionApproval.test(request) && environment.replaceAgentHeaders.filter(x => request.includes(x))?.length > 0 && environment.ignoreReplaceAgentHeaders.filter(x => request.includes(x))?.length === 0;
      } else {
        return false;
      }
    }

    return false;
  }
  getRepresentativeId(){
    if(sessionStorage.getItem('representative') !== null){
      this.representative =  JSON.parse(sessionStorage.getItem('representative'));
      return this.representative?.agent?.id ?? this.representative.agentUserId;
    }else {
      let user: User = JSON.parse(sessionStorage.getItem('user'));
      return user.id;
    }
  }

  getUser() {
    if (sessionStorage.getItem("user") != null) {
      let user: User = JSON.parse(sessionStorage.getItem('user'));
      return user;
    } else {
      this.auth.user$.subscribe((user) => {
        if (user != null) {
          return user;
        }
      })
    }
  }

  getTenantId() {
    if (sessionStorage.getItem("selectedTenant") != null) {
      let tenantId: any = JSON.parse(sessionStorage.getItem('selectedTenant'));
      return tenantId;
    } else {
      this.nav.tenantId$.subscribe(id => {
        return id;
      })
    }
  }

  getTenantName() {
    if (sessionStorage.getItem("selectedTenant") != null) {
      let tenantId: any = JSON.parse(sessionStorage.getItem('selectedTenant'));
      let tenantName = "";
      this.nav.tenants.forEach(tenant => {
        if (tenant.id == tenantId) {
           tenantName = tenant.name;
        }
      });
      return tenantName;
    } else {
      return "";
    }
  }

  getTenants() {
    if (sessionStorage.getItem("tenants") != null) {
      return JSON.parse(sessionStorage.getItem('tenants')) as Tenant[];
    } else {
      this.auth.tenants$.subscribe(tenants => {
        if (tenants != null) {
          return tenants;
        }
      })
    }
  }

  /**
   * Checks if the current user has a specific role stored in session storage.
   *
   * @param roleName - The name of the role to check.
   * @returns {boolean} - True if the user has the specified role, false otherwise.
   *
   */
  doesUserHaveRole(roleName: String) {
    let roleFound = false;
    if (sessionStorage.getItem("roles") !== null) {
      let userRoles = JSON.parse(sessionStorage.getItem("roles")) as Role[];
      userRoles.forEach(role => {
        if (role.name === roleName) {
          roleFound = true;
        }
      });
    }
    return roleFound;
  }

  getDistanceFromLatLonInM(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in kilometers
    var dLat = this.deg2rad(lat2 - lat1);
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in KM
    return d * 1000; // Distance in M
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        return position;
      });
    } else {
      return null;
    }
  }

  getTranslationByName(list, type) {
    this.tmpList = [];
    list.forEach(item => {
      item.name = this.translate.instant(type + item.name.replaceAll(" ", ""));
      this.tmpList.push(item);
    });
    return this.tmpList;
  }

  getTranslationByType(listB, sort) {
    this.tmpList1 = [];
    listB.forEach(item => {
      item.type = this.translate.instant(sort + item.type.replaceAll(" ", ""));
      this.tmpList1.push(item);
    });
    return this.tmpList1;
  }
}
